import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Box from '@amzn/meridian/box';
import BreadCrumbs from 'src/components/shared/breadcrumbs/breadcrumbs';
import { setSelectedTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import {
  ADMIN_CONFIG_PATHS,
  ADMIN_CONFIG_TABS,
  AdminConfigTabMap,
} from 'src/store/adminConfigPageSlice/common/constants';
import { useAppSelector } from 'src/store/store';

import './adminConfiguration.scss';

import FormTaskConfiguration from './formTaskConfiguration/formTaskConfiguration';
import JobModificationConfig from './modificationConfig/modificationConfig';
import RestrictionFormConfiguration from './restrictionFormConfiguration/restrictionFormConfiguration';
import SiteConfiguration from './siteConfiguration/siteConfiguration';
import TabGroup from './tabGroup/tabGroup';
import TaskConfiguration from './taskConfiguration/taskConfiguration';

/**
 * Default configuration
 */
const AdminConfiguration = () => {
  const { selectedTab } = useAppSelector((state) => state.adminConfigPage);
  const dispatch = useDispatch();
  const location = useLocation();

  // Set tab from URL
  useEffect(() => {
    const tab = AdminConfigTabMap.get(location.pathname);
    if (!!tab) {
      dispatch(setSelectedTab(tab));
    }
  }, []);

  return (
    <div className="admin-configuration">
      <BreadCrumbs
        breadcrumbList={[
          { label: 'Return To Work 2.0', url: '/' },
          { label: 'Admin Portal', url: ADMIN_CONFIG_PATHS.Root },
        ]}
      />
      <div className="admin-configuration__tab-group">
        <TabGroup />
      </div>
      <Box type="outline" spacingInset="200 500 400 500" className="admin-configuration__content">
        {selectedTab === ADMIN_CONFIG_TABS.Site ? (
          <SiteConfiguration />
        ) : selectedTab === ADMIN_CONFIG_TABS.Task ? (
          <TaskConfiguration />
        ) : selectedTab === ADMIN_CONFIG_TABS.Form ? (
          <RestrictionFormConfiguration />
        ) : selectedTab === ADMIN_CONFIG_TABS.FormTaskConfig ? (
          <FormTaskConfiguration />
        ) : selectedTab === ADMIN_CONFIG_TABS.Modification ? (
          <JobModificationConfig />
        ) : null}
      </Box>
    </div>
  );
};

export default AdminConfiguration;
